import $ from 'jquery';

const $blocks = $('.columns-block__block');

$blocks.each((i, el) => {
	const $block = $(el);
	const $trigger = $block.find('.read_more_button');

	$trigger.on('click', (e) => {
	$block.toggleClass('read-more--active');
	})
});
